module.exports = __webpack_public_path__ + "static/media/Illus-LoyaltyBloom@2x.03d9f97a.png";